<template>
  <video
    v-if="noWrapper"
    ref="videoRef"
    controls
    :poster="video.thumbnail"
    :width="video.width"
    :height="video.height"
    :autoplay="autoplay && isMobile"
    class="w-full min-w-[80vw] max-h-[80vh] h-auto!"
  >
    <source :src="video.source">
  </video>
  <div
    v-else
    class="relative w-full pt-[66.73%] bg-black"
  >
    <video
      ref="videoRef"
      controls
      :poster="video.thumbnail"
      :width="video.width"
      :height="video.height"
      :autoplay="autoplay && isMobile"
      class="absolute top-0 left-0 w-full h-full"
    >
      <source :src="video.source">
    </video>
    <AtomTransition timing="fast">
      <div
        v-show="shouldShowPlayButton"
        class="absolute inset-0 flex items-center justify-center transition-all cursor-pointer group"
        @click="handleClick"
      >
        <TIcon
          :icon="['fas', 'circle-play']"
          class="text-white w-12 h-12 transition-transform md:w-16 md:h-16 group-hover:scale-105"
        />
      </div>
    </AtomTransition>
  </div>
</template>

<script setup lang="ts">
import type { SwipeVideo } from '~/components/_tailwind/swipe/types'

const props = defineProps<{
  video: SwipeVideo
  noWrapper?: boolean
  noClick?: boolean
  autoplay?: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const { isWebView } = usePlatform()
const { isMobile } = useDevice()

const videoRef = ref()
const isVideoPlaying = ref(false)

const videoElement = computed(() => videoRef.value)
const shouldShowPlayButton = computed(() => !isVideoPlaying.value && !(isMobile || isWebView.value))

function handleClick() {
  if (props.noClick) {
    emit('click')
  }
  else {
    playVideo()
  }
}

function playVideo() {
  // The video needs to be ready to actually be played.
  // See: https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
  if (videoElement.value.readyState === 4) {
    isVideoPlaying.value = true

    videoElement.value.play()
  }
}
</script>
